<ion-header mode="md" no-border>
  <ion-toolbar mode="md" color="danger">
    <ion-title>
      {{ 'goalsInput.feedbackGoalsRejected' | translate }}
    </ion-title>
    <ion-buttons slot="end">
        <ion-button mode="ios" size="small" color="light" (click)="dismiss()" >
          <ion-icon class="bp-close"></ion-icon>
        </ion-button>
      </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="user-details">
    <img [src]="getImageUrl(manager?.imageUrl)" default="" alt="">
    <div class="user-title">
      <h2>{{manager?.username}}</h2>
      <p>{{ 'generic.manager' | translate }}</p>
    </div>
  </div>
  <ion-list mode="ios" lines="full" feedbar-detail>
    <ion-list-header mode="ios">
      <ion-label class="ion-text-wrap">
        {{ 'goalsInput.goalsRejected' | translate }}
      </ion-label>
    </ion-list-header>
    <ng-container *ngFor="let goal of rejectedGoals" >
      <ion-item>
        <ion-label class="ion-text-wrap">
          <h2>{{ goal.title }}</h2>
          <p>{{ goal.description }}</p>
          <p class="fwm">
            Deadline: {{ goal.deadline | date : 'dd/MM/yyyy' }}
          </p>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-label class="ion-text-wrap">
          <h2>{{ ('generic.comments' | translate) | uppercase }}</h2>
          <p>{{ goal.managerComment || '--' }}</p>
        </ion-label>
      </ion-item>
    </ng-container>
  </ion-list>

</ion-content>

<ion-footer mode="ios">
  <ion-toolbar mode="ios">
    <ion-row>
      <ion-col size="12">
        <ion-button color="secondary" expand="block" mode="ios"
          (click)="dismiss()" >
          OK
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>